import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dd58505a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mod_wrap mod_set_wrap" }
const _hoisted_2 = { class: "mod_c_title flex between" }
const _hoisted_3 = { class: "main-content" }
const _hoisted_4 = {
  key: 0,
  class: "bank-list"
}
const _hoisted_5 = { class: "flex between" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "used" }, null, -1))
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "not-use" }, null, -1))
const _hoisted_11 = ["src", "onClick"]
const _hoisted_12 = {
  key: 1,
  class: "bank-list"
}
const _hoisted_13 = {
  key: 2,
  class: "bank-list"
}
const _hoisted_14 = {
  class: "flex between",
  style: {"margin-bottom":"20px"}
}
const _hoisted_15 = { class: "usage-record-title" }
const _hoisted_16 = { style: {"min-height":"500px"} }

import CDelModal from '@/components/CDelModal.vue';
import { useRoute } from 'vue-router';
import router from '@/router';
import http from '@/api/redpacket';
import Crumb from '@/components/Crumb.vue';
import { ref, reactive, unref, computed } from 'vue';
import { ColumnProps } from 'ant-design-vue/es/table/interface';
import { documentPreview } from '@/assets';
import NewQuestion from './components/newQuestion.vue'; // 创建 or 编辑题库
import RedEnvelopeRecord from './components/redEnvelopeRecord.vue'; // 红包记录
import moment from 'moment';
import { RollbackOutlined } from '@ant-design/icons-vue';
import { Table, Pagination, Modal, message, DatePicker } from 'ant-design-vue';
// const CIcon = Icon;
type Key = ColumnProps['key'];
interface DataItem {
  title: string;
  answer_num: number;
  id: number;
  status: number;
  key: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CompetitiveRedEnvelope',
  setup(__props) {

const route = useRoute();
const studioId = router.currentRoute.value.params.studioId;


const { RangePicker } = DatePicker;
// const aTabs = Tabs;
// const aTabPane = Tabs.TabPane;
const aTable = Table;
const aPagination = Pagination;
const aModal = Modal;
const aRangePicker = RangePicker;

const operation = reactive({
  activeKey: ref(1),
  choice_all: ref(false), // 全选状态
  choice_arr: ref<Key[]>([]), // 勾选数组
  deletes: ref(false), // 删除弹窗
  questions_id: ref(''), // 编辑题库id
  questions_title: ref(''), // 题库标题
  usage_record: ref(false), // 使用记录弹窗
  usageRecordList: ref([]), // 使用记录
  use_type: ref(''), // 使用记录筛选
  use_time_filter: ref<Date[]>([]), // 使用记录时间筛选
});

const showLoading = ref<boolean>(false);

// 红包类型
const recordTypes = ref([
  {
    label: '全部',
    value: '',
  },
  {
    label: '现金红包',
    value: '1',
  },
  {
    label: '自定义红包',
    value: '2',
  },
]);

const callback = (key: any) => {
  key == 1 ? contestList(1) : key == 2 ? '' : '';
  operation.questions_id = '';
  operation.choice_all = false;
  onSelectChange([]);
};

/** 题库列表 */
const tableList = ref<DataItem[]>([]);
const columns = ref([
  {
    title: '题库名称',
    dataIndex: 'title',
    align: 'center',
  },
  {
    title: '答题人数',
    dataIndex: 'answer_num',
    align: 'center',
  },
  {
    title: '状态',
    align: 'center',
    dataIndex: 'status',
    width: '20%',
    slots: {
      customRender: 'status',
    },
  },
  {
    title: '使用记录',
    align: 'center',
    dataIndex: 'answer_record',
    slots: {
      customRender: 'answer_record',
    },
  },
  {
    title: '操作',
    dataIndex: 'edit',
    align: 'center',
    slots: {
      customRender: 'edit',
    },
  },
]);

const pageConfig = reactive({
  current: 1, // 当前页
  pageSize: 12, // 每页条数
  totalSize: 1, // 总页数
  options: ['12', '24', '36', '48', '60'], // 选项
  size: 'small', // 尺寸
  showJumper: false, // 是否显示跳页
  showSize: false, // 是否显示条数切换
});

// 全选
const rowSelection = computed(() => {
  return {
    selectedRowKeys: unref(selectedRowKeys),
    onChange: onSelectChange,
  };
});

const selectedRowKeys = ref<Key[]>([]);
const onSelectChange = (changableRowKeys: Key[]) => {
  operation.choice_arr = changableRowKeys;
  selectedRowKeys.value = changableRowKeys;
  operation.choice_all = changableRowKeys.length == tableList.value.length ? true : false;
};

const changeCheckAll = () => {
  let arr: any = [];
  operation.choice_all
    ? (tableList.value.forEach((i: any) => {
        arr.push(i.id);
      }),
      onSelectChange(arr))
    : onSelectChange([]);
};

// 竞答红包题库列表
const contestList = (current: number) => {
  let params = {
    studio_id: studioId,
    page: current,
    page_num: pageConfig.pageSize,
  };
  pageConfig.current = current;
  showLoading.value = true;
  http
    .contestList({ params })
    .then((res) => {
      showLoading.value = false;
      if (res.data.code == 200) {
        tableList.value = res.data.data.data;
        pageConfig.totalSize = res.data.data.total;
      }
    })
    .catch(() => {
      showLoading.value = false;
    });
};

// 查看题库使用记录
const viewListInfo = (item: any) => {
  operation.usage_record = true;
  operation.questions_id = item.id;
  operation.questions_title = item.title;
  getContestUseInfo(1);
};

const columns3 = ref([
  {
    title: '红包ID',
    dataIndex: 'id',
    align: 'center',
  },
  {
    title: '红包类型',
    dataIndex: 'type_title',
    align: 'center',
  },
  {
    title: '奖品',
    align: 'center',
    dataIndex: 'prize_title',
  },
  {
    title: '使用时间',
    align: 'center',
    dataIndex: 'created_at',
  },
]);

const usageRecordConfig = reactive({
  current: 1, // 当前页
  pageSize: 10, // 每页条数
  totalSize: 1, // 总页数
});

// 关闭使用记录弹窗
const usageRecordCancel = () => {
  operation.use_time_filter = [];
  operation.use_type = '';
};

// 获取使用记录
const getContestUseInfo = (current: number) => {
  let params = {
    studio_id: studioId,
    question_id: operation.questions_id,
    type: operation.use_type,
    start_at: operation.use_time_filter[0] ? new Date(operation.use_time_filter[0]) : operation.use_time_filter[0],
    end_at: operation.use_time_filter[1] ? new Date(operation.use_time_filter[1]) : operation.use_time_filter[1],
    page: current,
    page_num: usageRecordConfig.pageSize,
  };
  usageRecordConfig.current = current;
  showLoading.value = true;
  http
    .getContestUseInfo({ params })
    .then((res) => {
      showLoading.value = false;
      if (res.data.code == 200) {
        operation.usageRecordList = res.data.data.data;
        usageRecordConfig.totalSize = res.data.data.total;
      }
    })
    .catch(() => {
      showLoading.value = false;
    });
};

// 编辑题库
const editListInfo = (item: any) => {
  item ? (operation.questions_id = item.id) : (operation.questions_id = '');
  operation.activeKey = 2;
};

// 删除题库
const delContest = () => {
  let params = {
    contest_ids: operation.choice_arr.join(','),
    studio_id: studioId,
  };
  http
    .delContest({ params })
    .then((res) => {
      if (res.data.code == 200) {
        message.success(res.data.message);
        contestList(1);
        operation.deletes = false;
      }
    })
    .catch((res) => {
      operation.deletes = false;
      message.error(res.data.error);
    });
};
const openDelModal = () => {
  operation.deletes = false;
};
// 新建or编辑 保存状态
const getCreateStatus = (data: any) => {
  operation.activeKey = data;
  contestList(1);
};
const init = () => {
  contestList(1);
};

init();

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Crumb),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(_toDisplayString(_unref(route).meta?.title) + " ", 1),
        (operation.activeKey != 1)
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (operation.activeKey = 1))
            }, {
              icon: _withCtx(() => [
                _createVNode(_unref(RollbackOutlined))
              ]),
              default: _withCtx(() => [
                _createTextVNode("返回列表 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        (operation.activeKey == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_a_button, {
                    class: "mod_search_form_func",
                    type: "primary",
                    onClick: editListInfo
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("新建题库")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_button, {
                    class: "mod_search_form_func",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (operation.activeKey = 3))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("红包记录")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_a_checkbox, {
                    class: "checkbox",
                    checked: operation.choice_all,
                    "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((operation.choice_all) = $event)),
                    onChange: changeCheckAll
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("全选")
                    ]),
                    _: 1
                  }, 8, ["checked"]),
                  _createVNode(_component_a_button, {
                    class: "mod_btn",
                    type: "link",
                    disabled: operation.choice_arr.length <= 0,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (operation.deletes = true)),
                    danger: ""
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_svg_icon, {
                        class: "mod_btn_icon",
                        "icon-class": "del"
                      })
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" 删除 ")
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ]),
              _createVNode(_unref(aTable), {
                loading: showLoading.value,
                "row-selection": _unref(rowSelection),
                columns: columns.value,
                "data-source": tableList.value,
                pagination: false,
                class: "table-list",
                rowKey: 
            (res) => {
              return res.id;
            }
          
              }, {
                status: _withCtx(({ record }) => [
                  (record.status == 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                        _hoisted_8,
                        _createTextVNode("使用中 ")
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_9, [
                        _hoisted_10,
                        _createTextVNode("未使用 ")
                      ]))
                ]),
                edit: _withCtx(({ record }) => [
                  _createVNode(_component_svg_icon, {
                    class: "mod_select_icon cursor",
                    "icon-class": "operation",
                    onClick: ($event: any) => (editListInfo(record))
                  }, null, 8, ["onClick"])
                ]),
                answer_record: _withCtx(({ record }) => [
                  _createElementVNode("img", {
                    src: _unref(documentPreview),
                    class: "img_ww cursor",
                    onClick: ($event: any) => (viewListInfo(record))
                  }, null, 8, _hoisted_11)
                ]),
                _: 1
              }, 8, ["loading", "row-selection", "columns", "data-source", "rowKey"]),
              _createVNode(_unref(aPagination), {
                "show-quick-jumper": "",
                total: pageConfig.totalSize,
                current: pageConfig.current,
                "onUpdate:current": _cache[4] || (_cache[4] = ($event: any) => ((pageConfig.current) = $event)),
                "page-size": pageConfig.pageSize,
                "onUpdate:pageSize": _cache[5] || (_cache[5] = ($event: any) => ((pageConfig.pageSize) = $event)),
                pageSizeOptions: pageConfig.options,
                "show-less-items": "",
                "show-size-changer": "",
                onChange: _cache[6] || (_cache[6] = ($event: any) => (contestList(pageConfig.current))),
                onShowSizeChange: _cache[7] || (_cache[7] = ($event: any) => (contestList(pageConfig.current)))
              }, null, 8, ["total", "current", "page-size", "pageSizeOptions"])
            ]))
          : _createCommentVNode("", true),
        (operation.activeKey == 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(NewQuestion, {
                "data-source": {
            studioId: _unref(studioId),
            questionId: operation.questions_id,
          },
                onCreateStatus: getCreateStatus
              }, null, 8, ["data-source"])
            ]))
          : _createCommentVNode("", true),
        (operation.activeKey == 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(RedEnvelopeRecord)
            ]))
          : _createCommentVNode("", true),
        _createVNode(CDelModal, {
          visible: operation.deletes,
          centered: "",
          ok: delContest,
          close: openDelModal
        }, null, 8, ["visible"]),
        _createVNode(_unref(aModal), {
          visible: operation.usage_record,
          "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => ((operation.usage_record) = $event)),
          title: "使用记录",
          class: "bill-model",
          width: "900px",
          footer: null,
          onCancel: usageRecordCancel,
          centered: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", null, [
                _createVNode(_component_a_select, {
                  class: "select mod_select",
                  options: recordTypes.value,
                  placeholder: "全部",
                  value: operation.use_type,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((operation.use_type) = $event)),
                  onChange: _cache[9] || (_cache[9] = ($event: any) => (getContestUseInfo(1)))
                }, {
                  suffixIcon: _withCtx(() => [
                    _createVNode(_component_svg_icon, {
                      class: "mod_select_icon",
                      "icon-class": "list_select"
                    })
                  ]),
                  _: 1
                }, 8, ["options", "value"]),
                _createVNode(_unref(aRangePicker), {
                  ranges: {
                今天: [_unref(moment)().startOf('day'), _unref(moment)().endOf('day')],
                最近一周: [_unref(moment)().startOf('day').subtract(1, 'weeks'), _unref(moment)()],
                最近一月: [_unref(moment)().startOf('day').subtract(1, 'months'), _unref(moment)()],
                最近三月: [_unref(moment)().startOf('day').subtract(3, 'months'), _unref(moment)()],
              },
                  "show-time": { format: 'HH:mm' },
                  format: "YYYY-MM-DD HH:mm",
                  value: operation.use_time_filter,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((operation.use_time_filter) = $event)),
                  class: "mod_range_picker container_textLeft_picker",
                  onChange: _cache[11] || (_cache[11] = ($event: any) => (getContestUseInfo(1)))
                }, {
                  suffixIcon: _withCtx(() => [
                    _createVNode(_component_svg_icon, { "icon-class": "icon_time" })
                  ]),
                  _: 1
                }, 8, ["ranges", "value"])
              ]),
              _createElementVNode("p", _hoisted_15, "题库名称：" + _toDisplayString(operation.questions_title), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_unref(aTable), {
                loading: showLoading.value,
                columns: columns3.value,
                "data-source": operation.usageRecordList,
                pagination: false,
                rowKey: 
              (res) => {
                return res.id;
              }
            ,
                bordered: ""
              }, null, 8, ["loading", "columns", "data-source", "rowKey"])
            ]),
            _createVNode(_unref(aPagination), {
              style: {"margin-top":"10px"},
              total: usageRecordConfig.totalSize,
              current: usageRecordConfig.current,
              "onUpdate:current": _cache[12] || (_cache[12] = ($event: any) => ((usageRecordConfig.current) = $event)),
              "page-size": usageRecordConfig.pageSize,
              "onUpdate:pageSize": _cache[13] || (_cache[13] = ($event: any) => ((usageRecordConfig.pageSize) = $event)),
              pagination: usageRecordConfig,
              onChange: _cache[14] || (_cache[14] = ($event: any) => (getContestUseInfo(usageRecordConfig.current))),
              "show-less-items": ""
            }, null, 8, ["total", "current", "page-size", "pagination"])
          ]),
          _: 1
        }, 8, ["visible"])
      ])
    ])
  ], 64))
}
}

})